import { render, staticRenderFns } from "./adjust-premium-edit.vue?vue&type=template&id=687bb5cb&scoped=true&"
import script from "./adjust-premium-edit.vue?vue&type=script&lang=js&"
export * from "./adjust-premium-edit.vue?vue&type=script&lang=js&"
import style0 from "./adjust-premium-edit.vue?vue&type=style&index=0&id=687bb5cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687bb5cb",
  null
  
)

export default component.exports